import { useState, useRef } from 'react';
import { TAGS } from '../../assets/mockData';
import { useUser } from '../../contexts/UserContext';
import { compressImage, fileToDataURL } from '../../utils/imageCompress';
import AvatarCropper from './AvatarCropper';

export default function ProfileEditor() {
  const { user, updateUser } = useUser();
  const [name, setName] = useState(user.name);
  const [bio, setBio] = useState(user.bio);
  const [tags, setTags] = useState(user.tags || []);
  const [showCropper, setShowCropper] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);
  const [saved, setSaved] = useState(false);
  const fileRef = useRef();

  const handleAvatarSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const compressed = await compressImage(file, { maxWidth: 600, maxHeight: 600 });
    const dataUrl = await fileToDataURL(compressed);
    setCropSrc(dataUrl);
    setShowCropper(true);
    if (fileRef.current) fileRef.current.value = '';
  };

  const handleCrop = (croppedDataUrl) => {
    updateUser({ avatar: croppedDataUrl });
  };

  const toggleTag = (tag) => {
    setTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const handleSave = () => {
    updateUser({ name, bio, tags });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const colors = ['#6c5ce7', '#00b894', '#e17055', '#0984e3', '#fdcb6e', '#e84393'];
  const avatarColor = colors[(user.name || '?').charCodeAt(0) % colors.length];

  return (
    <div className="profile-editor">
      <h2 className="page-title">个人资料</h2>

      <div className="profile-avatar-section">
        <div className="profile-avatar-wrapper" onClick={() => fileRef.current?.click()}>
          {user.avatar ? (
            <img src={user.avatar} alt="" className="profile-avatar-img" />
          ) : (
            <div className="profile-avatar-placeholder" style={{ background: avatarColor }}>
              {(user.name || '?')[0]}
            </div>
          )}
          <div className="profile-avatar-overlay">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" fill="none" stroke="white" strokeWidth="2" />
              <circle cx="12" cy="13" r="4" fill="none" stroke="white" strokeWidth="2" />
            </svg>
          </div>
        </div>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          onChange={handleAvatarSelect}
          style={{ display: 'none' }}
        />
        <p className="avatar-hint">点击更换头像</p>
      </div>

      <div className="profile-form">
        <div className="form-group">
          <label>昵称</label>
          <input
            type="text"
            className="form-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={20}
          />
        </div>

        <div className="form-group">
          <label>个人简介</label>
          <textarea
            className="form-textarea"
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            rows={3}
            maxLength={200}
          />
          <span className="char-count">{bio.length}/200</span>
        </div>

        <div className="form-group">
          <label>兴趣标签</label>
          <div className="profile-tag-list">
            {TAGS.map((tag) => (
              <button
                key={tag}
                className={`tag-option ${tags.includes(tag) ? 'selected' : ''}`}
                onClick={() => toggleTag(tag)}
              >
                #{tag}
              </button>
            ))}
          </div>
        </div>

        <button className="btn-primary save-btn" onClick={handleSave}>
          {saved ? '已保存 ✓' : '保存修改'}
        </button>
      </div>

      <AvatarCropper
        open={showCropper}
        imageSrc={cropSrc}
        onCrop={handleCrop}
        onClose={() => setShowCropper(false)}
      />
    </div>
  );
}
